import Link from '@components/Link';
import React from 'react';
import LogoImg from '../../images/aepsy_logo.svg';
import './_Logo.scss';

function Logo(props) {
    const mod_class = [
        'Logo',
        props.theme ? 'theme-' + props.theme : 'theme-dark',
    ].join(' ');

    const _link = props.to ? props.to : '/';
    return (
        <div className={mod_class}>
            {props.noLink ? (
                <LogoImg />
            ) : (
                <Link to={_link}>
                    <LogoImg />
                </Link>
            )}
        </div>
    );
}

export default Logo;
